<template>
  <aside class="desktop-sidebar surface">
    <div class="desktop-sidebar__brand">
      <BrandMark />
      <div>
        <div class="desktop-sidebar__name">{{ brandName }}</div>
        <div class="desktop-sidebar__sub">Сеть компьютерных клубов</div>
      </div>
    </div>

    <div class="desktop-sidebar__profile glass">
      <div class="desktop-sidebar__avatar">{{ initials }}</div>
      <div>
        <strong>{{ displayName }}</strong>
        <div class="text-faded">{{ user?.is_admin ? 'Администратор' : 'Резидент клуба' }}</div>
      </div>
    </div>

    <nav class="desktop-sidebar__nav">
      <router-link
        v-for="item in items"
        :key="item.to"
        :to="item.to"
        class="desktop-sidebar__link"
        active-class="is-active"
      >
        <BaseIcon :name="item.icon" />
        <span>{{ item.label }}</span>
      </router-link>
    </nav>

    <div class="desktop-sidebar__footer glass">
      <div>
        <div class="text-faded">Текущий клуб</div>
        <strong>{{ currentClub?.name || 'Не выбран' }}</strong>
      </div>
      <router-link to="/menu" class="desktop-sidebar__footer-link">Меню и аккаунт</router-link>
    </div>
  </aside>
</template>

<script>
import BrandMark from '../brand/BrandMark.vue';
import BaseIcon from '../ui/BaseIcon.vue';
import { initialsFromName, userDisplayName } from '../../utils/formatters';

export default {
  name: 'DesktopSidebar',
  components: { BrandMark, BaseIcon },
  props: {
    user: {
      type: Object,
      default: null,
    },
    currentClub: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      items: [
        { to: '/', label: 'Главная', icon: 'home' },
        { to: '/clubs', label: 'Клубы и поиск', icon: 'search' },
        { to: '/book', label: 'Забронировать', icon: 'plus' },
        { to: '/menu', label: 'Меню', icon: 'menu' },
      ],
    };
  },
  computed: {
    displayName() {
      return userDisplayName(this.user);
    },
    initials() {
      return initialsFromName(this.displayName);
    },
  },
};
</script>

<style scoped src="./DesktopSidebar.css"></style>